import React, { useState } from "react"
import { Dialog, Transition } from "@headlessui/react"
import { Fragment } from "react"

const capabilities = [
    "Search real racetracks and start a private Racing Line draft.",
    "Inspect the current line, its details, points, and closure state.",
    "Replace or append acceleration, braking, and coasting points.",
    "Update vehicle and visibility details.",
    "Undo and redo changes.",
    "Finish through the normal validation and save flow.",
]

export default function WebMcpInfo({ mode = "landing" }) {
    const [open, setOpen] = useState(false)

    return (
        <>
            <button
                type="button"
                onClick={() => setOpen(true)}
                className="rounded-full border border-gray-200 bg-white px-2.5 py-1 text-[11px] font-medium tracking-wide text-gray-500 shadow-sm hover:border-gray-300 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-offset-2"
                aria-label="Learn what WebMCP can do"
            >
                WebMCP
            </button>

            <Transition appear show={open} as={Fragment}>
                <Dialog as="div" className="relative z-[10000]" onClose={setOpen}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-150"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black/40" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-150"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-100"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <div className="w-full max-w-md transform rounded-2xl bg-white p-6 text-left shadow-xl transition-all">
                                    <Dialog.Title className="text-lg font-semibold text-gray-900">
                                        What can an AI assistant do?
                                    </Dialog.Title>
                                    <p className="mt-2 text-sm leading-6 text-gray-600">
                                        WebMCP lets a compatible assistant work with the Racing Line Editor through the same guarded controls you use{mode === "editor" ? " in this line" : " here"}.
                                    </p>
                                    <ul className="mt-4 space-y-2 text-sm text-gray-700">
                                        {capabilities.map(capability => (
                                            <li key={capability} className="flex gap-2">
                                                <span aria-hidden="true" className="mt-2 h-1.5 w-1.5 flex-none rounded-full bg-red-600" />
                                                <span>{capability}</span>
                                            </li>
                                        ))}
                                    </ul>
                                    <p className="mt-4 text-xs leading-5 text-gray-500">
                                        Authentication, ownership, free limits, validation, and publication rules remain unchanged.
                                    </p>
                                    <div className="mt-5 flex justify-end">
                                        <button
                                            type="button"
                                            onClick={() => setOpen(false)}
                                            className="rounded-lg bg-gray-900 px-4 py-2 text-sm font-medium text-white hover:bg-black focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-offset-2"
                                        >
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}
